import { active } from "@api/productPlans/active/path";
import { deactive } from "@api/productPlans/deactive/path";
import { apiPathFunc } from "@api/util/apiPathFunc";

import type { IExtractParams } from "@routes";

const pathBase = `/product-plans/`;
const pathById = `${pathBase}:planId/`;

export type IPathBaseParam = IExtractParams<typeof pathBase>;
export type IPathByIdParam = IExtractParams<typeof pathById>;

export const productPlans = {
  get: apiPathFunc(pathById),
  getAll: apiPathFunc(pathBase),
  post: apiPathFunc(pathBase),
  patch: apiPathFunc(pathById),
  active,
  deactive,
};
